import React, { useState } from 'react';

const CookieConsent = ({ onAccept, onReject }) => {
  const [isPolicyOpen, setIsPolicyOpen] = useState(false);
  const [isAccepted, setIsAccepted] = useState(() => {
    try {
      return localStorage.getItem('cookieConsent') === 'true';
    } catch {
      return false;
    }
  });

  const handleAccept = () => {
    try {
      localStorage.setItem('cookieConsent', 'true');
    } catch {
      // localStorage not available
    }
    setIsAccepted(true);
    onAccept?.();
  };

  const handleReject = () => {
    try {
      localStorage.setItem('cookieConsent', 'false');
    } catch {
      // localStorage not available
    }
    setIsAccepted(true);
    onReject?.();
  };

  if (isAccepted) {
    return null;
  }

  return (
    <div className="cookie-consent-banner fixed bottom-0 w-full bg-gray-100 text-gray-800 p-4 border-t border-gray-300 shadow-lg z-50" role="dialog" aria-label="Cookie consent banner">
      <div className="flex flex-col space-y-4">
        <p className="text-sm">
          This site uses cookies to enhance your experience. By clicking "Accept," you agree to the use of cookies.{' '}
          <button
            className="text-blue-600 underline hover:text-blue-800 transition"
            onClick={() => setIsPolicyOpen(!isPolicyOpen)}
            aria-expanded={isPolicyOpen}
            aria-controls="privacy-policy"
          >
            {isPolicyOpen ? 'Hide Privacy Policy' : 'View Privacy Policy'}
          </button>
        </p>

        {isPolicyOpen && (
          <div
            id="privacy-policy"
            className="bg-white border border-gray-300 rounded-lg p-4 text-sm shadow-md"
          >
            <h2 className="text-lg font-semibold mb-2">Privacy Policy</h2>
            <p>
              We use cookies to:
              <ul className="list-disc pl-5">
                <li>Measure site traffic and performance with analytics tools.</li>
                <li>Show relevant ads through advertising services.</li>
              </ul>
            </p>
            <p>
              For more details about how we handle your data, please read our{' '}
              <a
                href="/privacy.txt"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800 transition"
              >
                full privacy policy
              </a>.
            </p>
          </div>
        )}

        <div className="flex justify-end space-x-4">
          <button
            className="cookie-consent-accept-button bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
            onClick={handleAccept}
          >
            Accept
          </button>
          <button
            className="cookie-consent-reject-button bg-gray-600 text-white px-4 py-2 rounded-lg shadow hover:bg-gray-700 transition"
            onClick={handleReject}
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
